import { Avatar, Badge, Box, Flex, Heading, Icon, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { FiChevronRight, FiStar } from 'react-icons/fi';

export const FamilyMembersList = ({ members, onMemberClick }) => {
    if (members.length == 0 || !members) {
        return null;
    }

    return (
        <Box mt={8}>
            <Heading size='md' color='gray.800' mb={4}>
                Family Members
            </Heading>
            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                {members.map((member) => (
                    <Flex key={member.id} bg='white' p={4} borderRadius='xl' border='1px' borderColor='gray.100' boxShadow='sm' align='center' justify='space-between' cursor='pointer' transition='all 0.2s' _hover={{ transform: 'translateY(-2px)', boxShadow: 'md', borderColor: 'red.200' }} onClick={() => onMemberClick(member)}>
                        <Flex align='center' gap={4}>
                            <Avatar size='md' name={member.name} src={member.avatar} />
                            <VStack align='start' spacing={0}>
                                <Text fontWeight='bold' color='gray.800'>
                                    {member.name}
                                </Text>
                                <Flex align='center' gap={2} mt={1}>
                                    <Badge colorScheme={member.role === 'Parent' ? 'blue' : 'green'} variant='subtle' borderRadius='full' px={2}>
                                        {member.role}
                                    </Badge>
                                    {member.isMember && (
                                        <Badge colorScheme='red' variant='solid' borderRadius='full' px={2} display='flex' alignItems='center' gap={1}>
                                            <Icon as={FiStar} w={3} h={3} />
                                            Member
                                        </Badge>
                                    )}
                                </Flex>
                            </VStack>
                        </Flex>

                        <Flex align='center' gap={3}>
                            <VStack align='end' spacing={0}>
                                <Text fontSize='xs' color='gray.500'>
                                    Points
                                </Text>
                                <Text fontWeight='bold' color='red.600'>
                                    {member.points.toLocaleString('id-ID')}
                                </Text>
                            </VStack>
                            <Icon as={FiChevronRight} color='gray.400' />
                        </Flex>
                    </Flex>
                ))}
            </SimpleGrid>
        </Box>
    );
};
